export const USER_CLASSIFICATION = [
  'Freshman',
  'Sophomore',
  'Junior',
  'Senior',
  'Graduate',
  'Other',
] as const;

export type UserClassification = typeof USER_CLASSIFICATION[number];

export enum Classification {
  Freshman,
  Sophomore,
  Junior,
  Senior,
  Graduate,
  Other,
}
